<template>
    <div>
        <Transition name="fade-fast">
            <div
                v-if="isOpen"
                class="fixed inset-0 z-[9999] bg-black opacity-50"
            ></div>
        </Transition>
        <div
            class="fixed inset-0 z-[99999] bg-white dark:bg-slate-800 rounded-t-2xl transition-all duration-800 flex flex-col gap-6 transform pt-6 px-8"
            :class="isOpen ? translateClass : 'translate-y-[100%]'"
            style="transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)"
        >
            <div class="flex justify-between gap-4 items-start">
                <h2 class="text-lg xs:text-xl text-slate-800 dark:text-slate-100 font-medium">
                    {{ title }}
                </h2>
                <button
                    @click="emit('update:open', false)"
                    class="text-slate-800 dark:text-slate-100 mt-1 hover:text-gray-500 dark:hover:text-slate-400"
                >
                    <Icon icon="x" width="20" height="20" />
                </button>
            </div>
            <div class="flex flex-col flex-1 gap-4 items-center">
                <div class="w-full">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, watch, computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    open: {
        type: Boolean,
        default: false,
    },
    size: {
        type: String,
        default: 'lg',
    },
    title: {
        type: String,
        default: '',
    },
});

const isOpen = ref(false);
const translateClass = computed(() => {
    switch (props.size) {
        case 'xs':
            return 'translate-y-[75%]';
        case 'sm':
            return 'translate-y-[65%]';
        case 'md':
            return 'translate-y-[40%]';
        case 'lg':
            return 'translate-y-[10%]';
        default:
            return 'translate-y-[5%]';
    }
});

watch(
    () => props.open,
    (newVal) => {
        isOpen.value = newVal;
    },
    { immediate: true }
);

const emit = defineEmits(['update:open']);
</script>
